import React, { useEffect, useState } from "react";
import { stripeService } from "../../api/stripe.service";
import Loader from "../../assets/images/loader-2.gif";
import useSourAlert from "../../hooks/useSourAlert";
import SourAlert from "../../components/elements/SourAlert";

export default function RedirectToPortal() {
	const [error, setError] = useState(null);
	const [alertProps, showAlert] = useSourAlert();

	useEffect(() => {
		const redirect = async () => {
			try {
				const session = await stripeService.getPortalSession();
				if (session.url) {
					window.location.href = session.url;
				} else {
					console.error("No URL received for portal:", session);
					setError("No URL received for Stripe portal.");
				}
			} catch (error) {
				console.error("Error getting Stripe portal:", error);
				setError("Error getting Stripe portal");
			}
		};

		redirect();
	}, []);

	useEffect(() => {
		if (error) {
			showAlert({
				type: "error",
				title: "Error",
				description: error,
				okButtonText: "Retry",
				onOk: () => window.location.reload(),
			});
		}
	}, [error, showAlert]);

	return (
		<div className="redirect">
			<img src={Loader} alt="Loading..." className="loader" />
			<SourAlert {...alertProps} />
		</div>
	);
}
